import { ReactNode } from 'react'

import { HelperText, HelperTextProps } from '../HelperText/HelperText.js'

export type FormControlMetaProps = Omit<HelperTextProps, 'status' | 'role'> & {
  helperText?: string | ReactNode
  error?: ReactNode
  invalid?: boolean
  /**
   * Prefixes the announced error so screen readers know which field it belongs to.
   */
  label?: ReactNode
}

export const FormControlMeta = ({
  invalid,
  helperText,
  error,
  size,
  id,
  label,
}: FormControlMetaProps) => (
  <>
    {!invalid && helperText && (
      <HelperText size={size}>{helperText}</HelperText>
    )}
    {invalid && error && (
      <HelperText status="error" size={size} role="alert">
        {label ? <span className="sr-only">{label}: </span> : null}
        <span id={id}>{error}</span>
      </HelperText>
    )}
  </>
)
